import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations de l'étudiant", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Numéro Matricule :", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", null, "Nom :", -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, "Prénom :", -1)
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, "Email :", -1)
const _hoisted_17 = { key: 4 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, "Filière :", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: "/liste-demande-inscriptions",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Retour ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_ctx.demande?.numeroMatricule)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.numeroMatricule), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.nom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.nom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.prenom)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.prenom), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.email)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.email), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.demande?.filiere?.libelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("td", null, _toDisplayString(_ctx.demande?.filiere?.libelle), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}